const Footer = () => {
    return (
        <footer className="Footer">
                <div class="ft_menu">
                <ul>
                    <li class="first_be off"><a href="/footer/incruit">인재채용</a></li>|
                    <li class="off"><a href="/footer/partners">협력업체등록</a></li>|
                    <li class="mo_bl"><a href="/footer/notice_list">공지사항</a></li>|
                    <li><a href="/footer/faq_list">고객 센터</a></li>|
                    <li class="mo_bl"><a href="/footer/policy"><strong>개인정보처리방침</strong></a></li>|
                    <li><a href="/footer/agreement">이용약관</a></li>
                </ul>
                </div>

                <div className="mark_webaward"><p><span class="blind">web award korea 2017 프랜차이즈분야 대상2017</span></p></div>
               


                    <p class="copyright">COPYRIGHT<span>©</span>㈜한솥. ALL RIGHTS RESERVED.</p>
        </footer>
    );
}

export default Footer;